import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">This page has not been generated</h1>
        <p className="mt-2 text-base text-foreground-400">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">Tell me more about this page, so I can generate it</p>
        <a href="/" className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-home-line"></i></span>
          Back to Home
        </a>
      </div>
    </div>
  );
}